import { CcfTranslationKey } from '@nice-ccf/i18n';

export interface ColorDataStyleConfig {
    group: string;
    label: CcfTranslationKey;
    id: string;
    property: string;
    value: string;
}

export type CustomStyleConfig = Array<ColorDataStyleConfig>;
export const TEXT_COLOR_GROUP = 'TEXT_COLOR';
export const HIGHLIGHT_COLOR_GROUP = 'HIGHLIGHT_COLOR';

export const colorData:CustomStyleConfig = [
  {
    group: TEXT_COLOR_GROUP,
    id: 'color-black',
    label: 'black',
    property: 'color',
    value: '#000000',
  },
  {
    group: TEXT_COLOR_GROUP,
    id: 'color-pickled-bluewood',
    label: 'pickledBluewood',
    property: 'color',
    value: '#34495e',
  },
  {
    group: TEXT_COLOR_GROUP,
    id: 'color-oslo-gray',
    label: 'osloGray',
    property: 'color',
    value: '#7e8c8d',
  },
  {
    group: TEXT_COLOR_GROUP,
    id: 'color-pewter',
    label: 'pewter',
    property: 'color',
    value: '#95a5a6',
  },
  {
    group: TEXT_COLOR_GROUP,
    id: 'color-zumthor',
    label: 'zumthor',
    property: 'color',
    value: '#ced4d9',
  },
  {
    group: TEXT_COLOR_GROUP,
    id: 'color-athens-gray',
    label: 'athensGray',
    property: 'color',
    value: '#ecf0f1',
  },
  {
    group: TEXT_COLOR_GROUP,
    id: 'color-matisse',
    label: 'matisse',
    property: 'color',
    value: '#236fa1',
  },
  {
    group: TEXT_COLOR_GROUP,
    id: 'color-vivid-violet',
    label: 'vividViolet',
    property: 'color',
    value: '#843fa1',
  },
  {
    group: TEXT_COLOR_GROUP,
    id: 'color-golden-gate-bridge',
    label: 'goldenGateBridge',
    property: 'color',
    value: '#ba372a',
  },
  {
    group: TEXT_COLOR_GROUP,
    id: 'colorZest',
    label: 'zest',
    property: 'color',
    value: '#e67e23',
  },
  {
    group: TEXT_COLOR_GROUP,
    id: 'color-elf-green',
    label: 'elfGreen',
    property: 'color',
    value: '#169179',
  },
  {
    group: TEXT_COLOR_GROUP,
    id: 'color-bleu-de-france',
    label: 'bleuDeFrance',
    property: 'color',
    value: '#3598db',
  },
  {
    group: TEXT_COLOR_GROUP,
    id: 'color-rich-lilac',
    label: 'richLilac',
    property: 'color',
    value: '#b96ad9',
  },
  {
    group: TEXT_COLOR_GROUP,
    id: 'color-cg-red',
    label: 'cgRed',
    property: 'color',
    value: '#e03e2d',
  },
  {
    group: TEXT_COLOR_GROUP,
    id: 'color-jonquil',
    label: 'jonquil',
    property: 'color',
    value: '#f1c40f',
  },
  {
    group: TEXT_COLOR_GROUP,
    id: 'color-ufo-green',
    label: 'ufoGreen',
    property: 'color',
    value: '#2dc26b',
  },
  {
    group: TEXT_COLOR_GROUP,
    id: 'color-coral-candy',
    label: 'coralCandy',
    property: 'color',
    value: '#f8cac6',
  },
  {
    group: TEXT_COLOR_GROUP,
    id: 'color-tropical-blue',
    label: 'tropicalBlue',
    property: 'color',
    value: '#c2e0f4',
  },
  {
    group: TEXT_COLOR_GROUP,
    id: 'color-french-lilac',
    label: 'frenchLilac',
    property: 'color',
    value: '#eccafa',
  },
  {
    group: TEXT_COLOR_GROUP,
    id: 'color-astra',
    label: 'astra',
    property: 'color',
    value: '#fbeeb8',
  },
  {
    group: TEXT_COLOR_GROUP,
    id: 'color-aero-blue',
    label: 'aeroBlue',
    property: 'color',
    value: '#bfedd2',
  },
  {
    group: HIGHLIGHT_COLOR_GROUP,
    id: 'bgcolor-black',
    label: 'black',
    property: 'backgroundColor',
    value: '#000000',
  },
  {
    group: HIGHLIGHT_COLOR_GROUP,
    id: 'bgcolor-pickled-bluewood',
    label: 'pickledBluewood',
    property: 'backgroundColor',
    value: '#34495e',
  },
  {
    group: HIGHLIGHT_COLOR_GROUP,
    id: 'bgcolor-oslo-gray',
    label: 'osloGray',
    property: 'backgroundColor',
    value: '#7e8c8d',
  },
  {
    group: HIGHLIGHT_COLOR_GROUP,
    id: 'bgcolor-pewter',
    label: 'pewter',
    property: 'backgroundColor',
    value: '#95a5a6',
  },
  {
    group: HIGHLIGHT_COLOR_GROUP,
    id: 'bgcolor-zumthor',
    label: 'zumthor',
    property: 'backgroundColor',
    value: '#ced4d9',
  },
  {
    group: HIGHLIGHT_COLOR_GROUP,
    id: 'bgcolor-athens-gray',
    label: 'athensGray',
    property: 'backgroundColor',
    value: '#ecf0f1',
  },
  {
    group: HIGHLIGHT_COLOR_GROUP,
    id: 'bgcolor-matisse',
    label: 'matisse',
    property: 'backgroundColor',
    value: '#236fa1',
  },
  {
    group: HIGHLIGHT_COLOR_GROUP,
    id: 'bgcolor-vivid-violet',
    label: 'vividViolet',
    property: 'backgroundColor',
    value: '#843fa1',
  },
  {
    group: HIGHLIGHT_COLOR_GROUP,
    id: 'bgcolor-golden-gate-bridge',
    label: 'goldenGateBridge',
    property: 'backgroundColor',
    value: '#ba372a',
  },
  {
    group: HIGHLIGHT_COLOR_GROUP,
    id: 'bgcolor-zest',
    label: 'zest',
    property: 'backgroundColor',
    value: '#e67e23',
  },
  {
    group: HIGHLIGHT_COLOR_GROUP,
    id: 'bgcolor-elf-green',
    label: 'elfGreen',
    property: 'backgroundColor',
    value: '#169179',
  },
  {
    group: HIGHLIGHT_COLOR_GROUP,
    id: 'bgcolor-bleu-de-france',
    label: 'bleuDeFrance',
    property: 'backgroundColor',
    value: '#3598db',
  },
  {
    group: HIGHLIGHT_COLOR_GROUP,
    id: 'bgcolor-rich-lilac',
    label: 'richLilac',
    property: 'backgroundColor',
    value: '#b96ad9',
  },
  {
    group: HIGHLIGHT_COLOR_GROUP,
    id: 'bgcolor-cg-red',
    label: 'cgRed',
    property: 'backgroundColor',
    value: '#e03e2d',
  },
  {
    group: HIGHLIGHT_COLOR_GROUP,
    id: 'bgcolor-jonquil',
    label: 'jonquil',
    property: 'backgroundColor',
    value: '#f1c40f',
  },
  {
    group: HIGHLIGHT_COLOR_GROUP,
    id: 'bgcolor-ufo-green',
    label: 'ufoGreen',
    property: 'backgroundColor',
    value: '#2dc26b',
  },
  {
    group: HIGHLIGHT_COLOR_GROUP,
    id: 'bgcolor-coral-candy',
    label: 'coralCandy',
    property: 'backgroundColor',
    value: '#f8cac6',
  },
  {
    group: HIGHLIGHT_COLOR_GROUP,
    id: 'bgcolor-tropical-blue',
    label: 'tropicalBlue',
    property: 'backgroundColor',
    value: '#c2e0f4',
  },
  {
    group: HIGHLIGHT_COLOR_GROUP,
    id: 'bgcolor-french-lilac',
    label: 'frenchLilac',
    property: 'backgroundColor',
    value: '#eccafa',
  },
  {
    group: HIGHLIGHT_COLOR_GROUP,
    id: 'bgcolor-astra',
    label: 'astra',
    property: 'backgroundColor',
    value: '#fbeeb8',
  },
  {
    group: HIGHLIGHT_COLOR_GROUP,
    id: 'bgcolor-aero-blue',
    label: 'aeroBlue',
    property: 'backgroundColor',
    value: '#bfedd2',
  }
];

export default colorData;